import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteDiscordPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.deleteDiscordPerk,
  {
    mutationKey: ['deleteDiscordPerk'],
  },
)
